import { copyTextToClipboard, toast } from '@systemeio/ui'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { LinkIcon } from '@systemeio/ui/icons'

interface FormAffiliateLinkProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const FormAffiliateLink = ({ value }: FormAffiliateLinkProps) => {
  const { t } = useLocoTranslation()
  return (
    <label className="flex flex-col gap-1 text-xs font-medium sm:text-sm">
      <div className="flex w-full">
        <input
          className={`text-text-primary main-transition-colors border-text-secondary/30 focus:border-brand-primary placeholder:text-text-tertiary/70 disabled:bg-background-secondary w-full rounded-l-lg border px-4 py-2.5 focus:outline-hidden`}
          disabled
          type={'text'}
          value={value}
          spellCheck={false}
        />
        <button
          onClick={e => {
            e.preventDefault()
            copyTextToClipboard(value as string)
            toast.success(t('global.copy_clipboard'))
          }}
          className="bg-brand-primary hover:bg-brand-primary-hover ring-brand-primary flex items-center justify-center rounded-r-lg px-2 py-2.5 ring-offset-1 focus:outline-hidden focus-visible:ring-2 sm:px-4"
        >
          <LinkIcon className="fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]" />
        </button>
      </div>
    </label>
  )
}

export default FormAffiliateLink
